module.exports = "<app-nav></app-nav>\n<div class=\"router-wrap\">\n  \n  <router-outlet></router-outlet>\n\n</div>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main